import { API } from '@shared/types/api';
import { createCtx } from '@shared/util/context';
import { Values } from '../../utils/CardDraft';

export type FormErrors = { [key: string]: string };
export type FormPresubmitHookFunction = (
  values: Values,
) => void | Partial<Values> | Promise<Partial<Values>>;

export interface FormContext {
  values: Values;
  errors: FormErrors;
  isSubmitting: boolean;
  mode: 'EDIT' | 'CREATE';
  card: API.CardFragment;
  handleBlur(fieldName: string): () => void;
  setFieldValue(fieldName: string, value: any): void;
  setFieldError(fieldName: string, error: string | undefined): void;
  submitForm(): Promise<any>;
  registerPresubmitHook(name: string, hook: FormPresubmitHookFunction): void;
  unregisterPresubmitHook(name: string): void;
}

export const [useCardFormContext, CardFormContextProvider] = createCtx<FormContext>();
